import SiafLiteApiRepository from "../../external/siafLiteApi";

class GrupoProdutosService {
  constructor() {
    this.urlBase = "/estoque/grupo-produtos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllAssociations() {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/all`).get();
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  addImage(formData) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/upload/imagem`).post(
      formData,
    );
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  findOrCreateGruposProduto(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/find-create-grupos-produto`,
    ).patch(body);
  }
}

export default GrupoProdutosService;
